const privacyPolicyAgreed = (value) => value === '1';
export default privacyPolicyAgreed;
